var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AgencyService } from './../api/agency.service';
import { ProjectService } from './../api/project.service';
import { OnInit, OnDestroy, ElementRef, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectSearch } from '../models/index';
import { BaseComponent } from './base-component';
import { Subscription } from 'rxjs/Subscription';
import * as Raven from 'raven-js';
var PortfolioBaseComponent = /** @class */ (function (_super) {
    __extends(PortfolioBaseComponent, _super);
    function PortfolioBaseComponent(injector, route, projectService, router, agencyService, window) {
        var _this = _super.call(this, injector) || this;
        _this.route = route;
        _this.projectService = projectService;
        _this.router = router;
        _this.agencyService = agencyService;
        _this.window = window;
        _this.projects = [];
        _this.projectSearch = new ProjectSearch();
        _this.subscription = new Subscription();
        _this.timeoutId = null;
        _this.apiLoading = false;
        _this.page = 1;
        _this.endOfList = false;
        _this.type = 'project';
        return _this;
    }
    PortfolioBaseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription.add(this.route.data.subscribe(function (data) {
            if (data['projects'] && _this.validateRouteDataParams(data, ['projects'])) {
                _this.projects = data.projects;
            }
            else {
                _this.subscription.add(_this.route.queryParams.subscribe(function (params) {
                    _this.projectSearch = _this.projectService.decodeUrlParams(params);
                    if (_this.projectSearch)
                        _this.refreshProjects();
                }));
            }
        }));
        this.setTitle('Portofoliu ' + this.agencyService.agency.name);
    };
    PortfolioBaseComponent.prototype.filterProjects = function (status) {
        this.projectSearch.sale_status = status;
        this.search();
    };
    PortfolioBaseComponent.prototype.search = function () {
        var _this = this;
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(function () {
            for (var field in _this.projectSearch) {
                if (_this.projectSearch[field] === null
                    || _this.projectSearch[field] === undefined) {
                    delete _this.projectSearch[field];
                }
            }
            if (_this.window) {
                _this.router.navigate([_this.window.location.pathname], {
                    queryParams: _this.projectSearch
                });
            }
        }, 200);
    };
    PortfolioBaseComponent.prototype.refreshProjects = function () {
        this.page = 1;
        this.projects = [];
        this.apiLoading = false;
        this.endOfList = false;
        this.addProjects();
    };
    PortfolioBaseComponent.prototype.addProjects = function () {
        var _this = this;
        if (this.apiLoading) {
            this.apiLoading = false;
            return;
        }
        this.apiLoading = true;
        var currentPage = this.page++;
        Raven.captureBreadcrumb({
            message: 'addClients, page: ' + currentPage,
            category: 'projects infinite scroll'
        });
        this.projectService.getProjects(this.projectSearch, currentPage).then(function (projects) {
            _this.apiLoading = false;
            Raven.captureBreadcrumb({
                message: 'getProjects API resonse, page: ' + currentPage,
                category: 'projects infinite scroll'
            });
            if (currentPage === 1) {
                if (_this.projects.length) {
                    Raven.captureMessage('Projects list error: possbile duplication detected', { level: 'warning' });
                }
                _this.projects = projects;
            }
            else {
                _this.projects = _this.projects.concat(projects);
            }
            if (projects.length < 15) {
                _this.endOfList = true;
                return;
            }
        });
    };
    PortfolioBaseComponent.prototype.onScroll = function () {
        if (this.window) {
            if (this.listSection) {
                if (!this.endOfList && !this.apiLoading
                    && this.listSection.nativeElement.getBoundingClientRect().bottom - this.window.innerHeight < 0) {
                    this.addProjects();
                }
            }
            else {
                throw new Error('PortfolioBaseComponent error: listSection not defined');
            }
        }
    };
    PortfolioBaseComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        clearTimeout(this.timeoutId);
    };
    return PortfolioBaseComponent;
}(BaseComponent));
export { PortfolioBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/portfolio-base.component.ts.pre-build-optimizer.js